<template>
  <modal
    :nextRoute="{name: 'menuIndex',params: { userSlug: rawMenu.user.slug }}"
    :showCloseButton="true"
  >
    <div
      class="text-center my-3"
      slot="heading"
    >
      <h1 class="mb-0">
        <span class="font-weight-bold">About</span>
      </h1>
      <p class="small mb-0">
        {{rawMenu.user.name}}
      </p>
    </div>
    <div slot="content">
      {{rawMenu.user.about_text}}
    </div>
  </modal>
</template>

<style scoped>
</style>

<script>
import formLoader from "../../form/FormLoader";
import modal from "../../shared/Modal";
import pageMixin from "../../../mixins/pageMixin";
import formMixin from "../../../mixins/formMixin";
export default {
  mounted() {
    this.$gtag.pageview({
      page_title: "About " + this.rawMenu.user.name,
    });
  },
  data() {
    return {
      name: "",
      email: "",
      phone: "",
      enquiry: "",
      emptyRequiredMessage: "",
      success: false,
    };
  },
  metaInfo() {
    return {
      title: "About " + this.rawMenu.user.name,
      vmid: "title",
      meta: [
        {
          name: "description",
          vmid: "description",
          content: "About " + this.rawMenu.user.name,
        },
        {
          name: "og:title",
          vmid: "ogTitle",
          content: "Contact " + this.rawMenu.user.name,
        },
        {
          name: "og:description",
          vmid: "ogDescription",
          content: "Contact " + this.rawMenu.user.name,
        },
      ],
    };
  },
  methods: {},
  components: {
    modal,
  },
  mixins: [pageMixin],
};
</script>
